import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://tkvyoyumxqpzsxnprrkx.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRrdnlveXVteHFwenN4bnBycmt4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY5MTUzNzksImV4cCI6MjA3MjQ5MTM3OX0.0XYZHNLonuWp8Y05u9LmlrIfFiOkrTOmF68htufzmnQ'

if(SUPABASE_URL === 'https://<PROJECT-ID>.supabase.co' || SUPABASE_ANON_KEY === '<ANON_KEY>') {
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})